class Popup {
	constructor(param) {
		this.byDefault = {
			btnConfirm:'Ок',
			btnCancel:'Отмена'
		}
		this.create(param);
		this._add(param);
	}
	_add(data){
		var obj=this;
		this.name = this.param.name || 'popup-' + new Date().getTime();

		if(typeof data=='string') this.content.innerHTML=data;
		else if (typeof data.content=='string') this.content.innerHTML=data.content;
		else if (typeof data.content=='object') {
			this.popupInner=data.content;
			this.content.appendChild(data.content);
		}

		if(data.title){
			this.title.innerHTML=data.title;
			this.title.style.display = 'block';
		}
		else {
			this.title.innerHTML='';
			this.title.style.display = 'none';
		}

		this.isShowBtn(data.btnConfirm, 'btnConfirm');
		this.isShowBtn(data.btnCancel, 'btnCancel');

		if (data.btnConfirm || data.btnCancel) this.table.className = this.table.className + ' popup-controls';

		this.showX(data);

		this.table.className=this.table.className+' '+ (data.addClass || '');
	}

	showX(param){
		var self = this;
		for(var i=0,j=this.btnCloseAll.length; i<j; i++){
			this.btnCloseAll[i].onclick = function(event){
				event=event || window.event;
				event.preventDefault ? event.preventDefault() : (event.returnValue=false);
				self.close.call(self);
			}
		}
		if(param.autoClose) {
			//если шаблон прогрессбар запускаем таймер
		  	this.runTimer(param);
		}
	}

	isShowBtn(btn,name){
		var obj=this;
		if(btn){
			if(typeof btn=='boolean'){
				this[name].innerHTML=this.byDefault[name];
				this[name].onclick=function(event){
					event=event || window.event;
					event.preventDefault ? event.preventDefault() : (event.returnValue=false);
					obj.close.call(obj); return false;
				}
			}
			else if (typeof btn=='string'){
				this[name].innerHTML=btn;
				this[name].onclick=function(event){
					event=event || window.event;
					event.preventDefault ? event.preventDefault() : (event.returnValue=false);
					obj.close.call(obj); return false;
				}
			}
			else{
				this[name].innerHTML=btn.name || this.byDefault[name];

				this[name].onclick=function(event){
					event=event || window.event;
					event.preventDefault ? event.preventDefault() : (event.returnValue=false);

					if(btn.callback==undefined) obj.close.call(obj);
					else {
						if(!btn.callback()) obj.close.call(obj);
					}

					return false;
				}
			}
			//доб класс
			if(btn.className) var className=this[name].defaultClass+' ' + btn.className;
			else var className=this[name].defaultClass;
			this[name].className=className;

			this[name].className=this[name].className.replace(/ disabled/, '');
		}
		else this[name].className=this[name].className.replace(/ disabled/, '')+' disabled';
	}

	create(param){
		var obj=this;
		this.param = param;
		var popupClassName = 'popup ' + (this.param.addClass || '');

		this.disabled=false;
		this.countdownInterval = false;
		this.clearOpen = false; //
		this.clearClose=false; //чтобы избежать двойного закрытия
		this.mainFrame  = document.getElementById('main-frame');
		//this.rightContent  = document.getElementById('right-content');
		this.table = document.createElement('DIV');
		this.table.className=popupClassName;

		//шаблон с прогрессбаром, шаблон с крестиком
		if(param.autoClose) {
			this.table.innerHTML =
			'<div class="popup_frame">'+
			'<div class="popup_cell">'+
				'<div data-js="close" class="popup_bg"></div>'+
				'<div data-popup-opened data-popup-closed class="popup_container layer layer-reverse">'+
					'<a data-js="close" class="popup_close popup_progress" href="#">' +
						'<div class="popup_layer"></div>' +
						'<div class="popup_info">' +
							'<span class="popup_info_text">Реклама скроется через</span>' + 
							'<div class="popup_info_countdown"></div>' +
							'<div class="popup_info_close as-none js-deactivate"></div>' +
						'</div>' +
					'</a>'+
					'<span class="popup_title">'+
						'<!-- Заголовок -->'+
					'</span>'+
					'<div class="popup_content">'+
						'<!-- Содержимое -->'+
					'</div>'+
					'<div class="popup_btns">'+
						'<a href="#" class="popup_confirm popup_btn disabled">'+this.byDefault.btnConfirm+'</a>'+
						'<a href="#" class="popup_cancel popup_btn disabled">'+this.byDefault.btnCancel+'</a>'+
					'</div>'+
				'</div>'+
			'</div>'+
		'</div>';
		} else {
			this.table.innerHTML=
				'<div class="popup_frame">'+
					'<div class="popup_cell">'+
						'<div data-js="close" class="popup_bg"></div>'+
						'<div data-popup-opened data-popup-closed class="popup_container layer layer-reverse">'+
							'<a data-js="close" class="popup_close" href="#">' +
								'<svg class="symbol symbol-x symbol-x-popup" role="img"><use xlink:href="/static/img/symbols/sprite.svg#x"></use></svg>' +
							'</a>'+
							'<span class="popup_title">'+
								'<!-- Заголовок -->'+
							'</span>'+
							'<div class="popup_content">'+
								'<!-- Содержимое -->'+
							'</div>'+
							'<div class="popup_btns">'+
								'<a href="#" class="popup_confirm popup_btn disabled">'+this.byDefault.btnConfirm+'</a>'+
								'<a href="#" class="popup_cancel popup_btn disabled">'+this.byDefault.btnCancel+'</a>'+
							'</div>'+
						'</div>'+
					'</div>'+
				'</div>';
		}

		document.body.appendChild(this.table);
		this.container=this.table.querySelector('.popup_container');
		this.title=this.table.querySelector('.popup_title');
		this.content=this.table.querySelector('.popup_content');
		this.btnConfirm=this.table.querySelector('.popup_confirm') ;
		this.btnConfirm.defaultClass=this.btnConfirm.className;
		this.btnCancel=this.table.querySelector('.popup_cancel');
		this.btnCancel.defaultClass=this.btnCancel.className;
		this.btnCloseAll=this.table.querySelectorAll('[data-js="close"]');
		//this.closedElement = this.table.querySelector('[data-popup-closed]');
		//this.openedElement = this.table.querySelector('[data-popup-opened]');
		this.scrollWidth = window.innerWidth - document.body.clientWidth;
	}

	open(){
		if(this.disabled || this.clearOpen) return false;
		try{clearTimeout(this.clearClose)} catch(e){}

        if(this.param.onopenBefore && !this.param.onopenBefore()) return false;

		var self = this;

		if(uPopup.count === 0) {
			document.body.className=document.body.className + ' js-popup';
			document.body.style.paddingRight = this.scrollWidth + 'px';
			//this.rightContent.style.left = -this.scrollWidth/2 + 'px';
		}
		this.table.className=this.table.className.replace(/\s*active/, '')+' active';
		//this.container.className='popup_container'; //for ie<10

		uPopup.count+=1;

		this.clearOpen = setTimeout(function(){
			if(self.param.onopen) self.param.onopen(self.content);
			self.clearOpen = false;
		}, 600);
	}

	close() {
		if(this.disabled || this.clearClose) return false;
		try{
			clearTimeout(this.clearOpen)
			clearInterval(this.countdownInterval);
		} catch(e){
			console.error(e);
		}

		this.clearClose = true;

		if(this.param.oncloseBefore){
			if(!this.param.oncloseBefore()){
				this.clearClose = false;
				return false;
			}
		}

		var self = this;
		this.table.className=this.table.className.replace(/\s*active/, '');

		this.clearClose = setTimeout(function(){
			document.body.removeChild(self.table);
			try {document.body.appendChild(self.popupInner)} catch(e){};
			if(self.param.onclose) self.param.onclose();
			self.clearClose = false;
			if(uPopup.count === 1) {
				document.body.className=document.body.className.replace(/\s*js-popup/, '');
                document.body.style.paddingRight =  '0px';
				//self.rightContent.style.left = '0px';
			}

			uPopup.count-=1;
			delete uPopup.all[self.param.name];
		}, 600);
	}

	runTimer(param) {
        var bar,
            countdownNumberEl,
			layer,
			startTime,
			countdown;
        	//показываем тогглер в последнюю секунду
            countdown = param.autoClose/1000;
			bar = document.querySelector('.popup_progress');
			countdownNumberEl = bar.querySelector('.popup_info_countdown');
			let close = bar.querySelector('.popup_info_close');
            //Запускаем обратный отсчет
            countdownNumberEl.textContent = countdown;
			layer = bar.querySelector('.popup_layer');
			startTime = param.autoClose/1000;

            this.countdownInterval = setInterval(() => {
                countdown = --countdown <= 0 ? 0 : countdown;
				countdownNumberEl.textContent = countdown;
				//показываем крестик после 2 секунд
				if(startTime - 2 >= countdown) {
				    close.classList.remove('as-none');
				}
				if(countdown <= 0) {
					this.close.call(this);
				}
			  }, 900);
			//запускаем полосу
			layer.style.transition = `width ${countdown}s`;
			layer.style.width = '100%';
	}
}

export {Popup};